import { render, staticRenderFns } from "./ClaimStepper.vue?vue&type=template&id=1674ccdf&"
import script from "./ClaimStepper.vue?vue&type=script&lang=js&"
export * from "./ClaimStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports